export const TRANSLATE_COMMAND_ID = "translate";